"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_AREA_PUBBLICA_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetAreaPubblica,
    skipImportingInCMS: false,
}, {
    tpdFormIniziativeWidget: {
        __mfeName__: "tpdFormIniziativeWidget",
        devClientPort: 6323,
        devServerPort: 6423,
    },
    tpdGestioneUtenzeAziendaliDisabilitazioneWidget: {
        __mfeName__: "tpdGestioneUtenzeAziendaliDisabilitazioneWidget",
        devClientPort: 6326,
        devServerPort: 6426,
    },
    tpdVenditaIbridaUnsubscribeWidget: {
        __mfeName__: "tpdVenditaIbridaUnsubscribeWidget",
        devClientPort: 6327,
        devServerPort: 6427,
    },
    tpdGestioneComunicazioniWidget: {
        __mfeName__: "tpdGestioneComunicazioniWidget",
        devClientPort: 6330,
        devServerPort: 6430,
    },
    tpdComunicazioniConCTAWidget: {
        __mfeName__: "tpdComunicazioniConCTAWidget",
        devClientPort: 6331,
        devServerPort: 6431,
    },
    tpdRecuperaDocumentoWidget: {
        __mfeName__: "tpdRecuperaDocumentoWidget",
        devClientPort: 6333,
        devServerPort: 6433,
    },
    tpdBoxInfoCtaWidget: {
        __mfeName__: "tpdBoxInfoCtaWidget",
        devClientPort: 6332,
        devServerPort: 6432,
    },
    tpdIndexLinkedWidget: {
        __mfeName__: "tpdIndexLinkedWidget",
        devClientPort: 6335,
        devServerPort: 6435,
    },
    tpdRendicontiDettaglioGestioneSeparataWidget: {
        __mfeName__: "tpdRendicontiDettaglioGestioneSeparataWidget",
        devClientPort: 6338,
        devServerPort: 6438,
    },
    tpdRendicontiDettaglioUnitLinked: {
        __mfeName__: "tpdRendicontiDettaglioUnitLinked",
        devClientPort: 6339,
        devServerPort: 6439,
    },
    tpdPagamentoInsolutoWidget: {
        __mfeName__: "tpdPagamentoInsolutoWidget",
        devClientPort: 6341,
        devServerPort: 6441,
    },
    tpdSoccorsoAuto: {
        __mfeName__: "tpdSoccorsoAuto",
        devClientPort: 6045,
        devServerPort: 6145,
    },
    tpdCasellaRicercaFaiUnaDomanda: {
        __mfeName__: "tpdCasellaRicercaFaiUnaDomanda",
        devClientPort: 6068,
        devServerPort: 6168,
    },
    tpdCasellaRicercaHeader: {
        __mfeName__: "tpdCasellaRicercaHeader",
        devClientPort: 6003,
        devServerPort: 6103,
    },
    tpdFormRecuperaPreventivo: {
        __mfeName__: "tpdFormRecuperaPreventivo",
        devClientPort: 6004,
        devServerPort: 6104,
    },
    tpdUnitLinkedWidget: {
        __mfeName__: "tpdUnitLinkedWidget",
        devClientPort: 6088,
        devServerPort: 6188,
    },
    tpdVariazioneDatiAgenziali: {
        __mfeName__: "tpdVariazioneDatiAgenziali",
        devClientPort: 6052,
        devServerPort: 6152,
    },
    tpdCauzioniWidget: {
        __mfeName__: "tpdCauzioniWidget",
        devClientPort: 6318,
        devServerPort: 6418,
    },
    tpdGestioneUtenzeAziendaliWidget: {
        __mfeName__: "tpdGestioneUtenzeAziendaliWidget",
        devClientPort: 6070,
        devServerPort: 6170,
    },
});
exports.WIDGET_AREA_PUBBLICA_REMOTES_SETTINGS = settings;
